import { render, staticRenderFns } from "./ci_catalog_badge.vue.js?vue&type=template&id=cc14adca&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ci_catalog_badge.vue?vue&type=template&id=cc14adca&vue3"
import script from "./ci_catalog_badge.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ci_catalog_badge.vue?vue&type=script&lang=js&vue3"
export * from "./ci_catalog_badge.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ci_catalog_badge.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports